import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import ScrollRestorationContext from './ScrollRestorationContext';

type ScrollRestorationProviderType = {
  children: React.ReactNode;
};

const ScrollRestorationProvider: React.FC<ScrollRestorationProviderType> = ({
  children,
}) => {
  const [state, setState] = useState({});

  const { pathname } = useLocation();

  const saveScrollY = (scrollY: number) => {
    setState({
      ...state,
      [pathname]: scrollY,
    });
  };

  const getScrollY = (page: string) => state[page];

  const scrollTo = (page: string) => {
    const scrollY = getScrollY(page);
    if (scrollY) {
      setTimeout(() => {
        window.scrollTo({
          top: scrollY,
          left: 0,
          // behavior: 'smooth',
        });
        // window.scrollTo(0, scrollY);
      }, 100);
    }
  };

  const contextState = {
    saveScrollY,
    getScrollY,
    scrollTo,
    state: {},
  };

  return (
    <ScrollRestorationContext.Provider value={contextState}>
      {children}
    </ScrollRestorationContext.Provider>
  );
};

export default ScrollRestorationProvider;
